export type OrdinalCategory = 'one' | 'two' | 'few' | 'other';

/**
 * Selects the CLDR-style ordinal category for a locale and integer.
 *
 * This intentionally does not use `Intl.PluralRules` with `type: 'ordinal'`:
 * some iOS WebKit and Android Chromium versions ship without ordinal ICU data
 * and return `other` for every value.
 */
export function selectOrdinalCategory(
  locale: string | undefined,
  value: number
): OrdinalCategory {
  const language = locale?.split('-')[0];
  const mod10 = value % 10;
  const mod100 = value % 100;

  switch (language) {
    case 'en':
      if (mod10 === 1 && mod100 !== 11) return 'one';
      if (mod10 === 2 && mod100 !== 12) return 'two';
      if (mod10 === 3 && mod100 !== 13) return 'few';
      return 'other';
    case 'fr':
      return value === 1 ? 'one' : 'other';
    case 'ca':
      if (value === 1 || value === 3) return 'one';
      if (value === 2) return 'two';
      if (value === 4) return 'few';
      return 'other';
    default:
      return 'other';
  }
}
